import { SVGProps } from 'react';

export default function LeftArrow(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18" fill="none" preserveAspectRatio='none' {...props}>
      <path d="M8 18L1.18021e-06 9L8 1.04907e-06L8 18Z" fill="#FF00FE" />
    </svg>
  )
}